<template>
  <div class="message-container">
    <template v-if="userId">
      <div class="topTips">
        <buttom-tips />
      </div>
      <dl class="users-list">
        <dt class="users-title">
          <span class="title">消息</span>
          <span class="num">{{unreadCount}}条未读</span>
        </dt>
        <van-list v-if="!list || list.length > 0" v-model="isLoading" :finished="finished" finished-text="没有更多了"
          @load="fetchMessage" class="person-list">
          <dd class="users-item" v-for="(item, index) in mergeList" :key="index" @click="jump(item.fromMid, item.id, item)">
            <div class="head-box">
              <div class="img-box">
                <img v-if="item.fromMid" v-lazy="item.headPicUrl" alt="" class="img" />
                <img v-else src="/static/img/logo.png" alt="" class="img" />
              </div>
              <div v-show="item.status == 0">
                <span class="sentence-num"></span>
              </div>
            </div>
            <div class="infomation">
              <p class="name-box"><span class="name">{{item.fromMid == 0 ? 'Hello部落' : item.name}}</span><span
                  class="official" v-if="item.fromMid == 0">官方</span></p>
              <p class="sentence">{{item.message}}</p>
            </div>
          </dd>
        </van-list>
        <dd v-else>
          <!-- <dd> -->
          <p class="no-message-tips">当前暂未收到消息</p>
          <img src="~@/assets/img/no-search-result.png" alt="" class="no-message-img" />
        </dd>
      </dl>

      <van-dialog v-model="isShowDialog" :confirmButtonText="dialogConfirmText" @confirm="confirm" @closed="closed">
        <div id="user-message-dialog">
          <p class="tips">对于喜欢你的人，你只须要回点ta一个喜欢，即可免费获得对方的微信号</p>
          <div class="not-show-again" @click="checkKnown">
            <span class="check-box" :class="{'isChecked': notShowAgain}"><img v-if="notShowAgain"
                src="~@/assets/img/tick.png" /></span>
            <span class="known">已知悉，不再显示该提示</span>
          </div>
        </div>
      </van-dialog>

      <banModal v-model="showModal" />
    </template>

    <Login v-else />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Storage from '@/utils/Storage'
import Login from '@/components/common/login'
import buttomTips from '@/components/common/buttomTips'
import banModal from '../../personList/component/banModal'

export default {
  name: 'account',
  components: {
    Login,
    buttomTips,
    banModal
  },
  data () {
    return {
      list: undefined,
      currentId: undefined,
      isShowDialog: false,
      dialogConfirmText: '我知道了',
      notShowAgain: false,
      unWatcher: null,
      currentPage: 1,
      pageSize: 20,
      isLoading: false,
      finished: false,
      showModal: false
    }
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapState('message', {
      unreadCount: 'unreadCount'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    /**
     * @description 将消息列表重构成以下形式
     *  1、官方消息合并
     *  2、官方消息排在首位
     *  3、合并后的官方消息，ids为未读消息数组
     */
    mergeList () {
      let list = []
      let official = null
      let ids = []
      if (this.list) {
        list = this.list.filter(item => {
          if (item.fromMid == 0) {
            // 官方消息
            if (item.status == 0) {
              ids.push(item.id)
            }
            official = item
          } else {
            return true
          }
        })
      }
      if (official) {
        if (ids.length) {
          official.ids = ids
        }
        // 官方消息排在首位
        list.unshift(official)
      }
      return list
    }
  },
  methods: {
    ...mapMutations('message', {
      updateUnreadCount: 'updateUnreadCount'
    }),
    jump (userId, id, item) {
      if (!userId) {
        // 官方消息
        this.$router.push({
          path: `/message-detail-${userId === '' ? 0 : userId}.html`
        })
      } else {
        if (item.singleStatus === 6 || item.singleStatus === 7) {
          this.showModal = true
        } else {
          this.popup(userId)
        }
      }
      (item.status == 0 || item.ids || item.id) && this.$http('/api/member/message/read', {
        targetMemberId: item.fromMemberId
      }).then(res => {
        if (res.code === '0000') {
          item.status = 1
          if (this.unreadCount > 0) {
            let num = item.ids ? item.ids.length : 1
            this.updateUnreadCount(this.unreadCount - num)
          }
        } else {
          this.$toast(res.msg)
        }
        this.isLoading = false
      }, err => {
        this.isLoading = false
        this.$toast(err)
      })
    },
    toDetail () {
      this.$router.push({
        path: `/info-${this.currentId}.html`
      })
    },
    popup (id) {
      this.currentId = id
      if (!Storage.load('neverPopMessage')) {
        this.isShowDialog = true
        return
      }

      // 直接跳转到个人详情页
      this.toDetail()
    },
    checkKnown () {
      this.notShowAgain = !this.notShowAgain
    },
    confirm () {
      if (this.notShowAgain) {
        Storage.save('neverPopMessage', true)
      } else {
        Storage.save('neverPopMessage', false)
      }
    },
    closed () {
      // 直接跳转到个人详情页
      this.toDetail()
    },
    fetchMessage () {
      this.isLoading = true
      this.$http('/api/member/message/list', {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000') {
          this.list = res.data.data || []
          if (this.currentPage >= res.data.pageCount) {
            this.finished = true
          } else {
            this.finished = false
          }
          this.currentPage++
        } else {
          res.code !== '100005' && this.$toast(res.msg)
          this.finished = true
        }
      }, err => {
        this.isLoading = false
        this.$toast(err)
      })
    }
  },
  watch: {
    userId (val) {
      this.currentPage = 1
      this.fetchMessage()
    }
  },
  activated () {
    this.unWatcher = this.$watch('unreadCount', (val) => {
      if (parseInt(val) >= 0) {
        this.currentPage = 1
        this.fetchMessage()
      }
    })
  },
  deactivated () {
    this.unWatcher && this.unWatcher()
  },
  mounted () {
    this.userId && this.fetchMessage()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.message-container {
  .van-list__finished-text {
    margin-top: 30px;
  }
  .no-message-tips {
    margin-top: 100px;
    color: #9b9b9b;
    font-size: 26px;
    line-height: 38px;
    text-align: center;
  }
  .no-message-img {
    margin: 60px auto 0;
    display: block;
    width: 166px;
  }
}
</style>
